import { CustomLevel } from './EditorTypes';

export function exportLevel(level: CustomLevel): string {
  return JSON.stringify(level, null, 2);
}

export function importLevel(json: string): CustomLevel {
  try {
    const level = JSON.parse(json);
    
    // Validate structure
    if (!level.name || !level.entities || !level.wordBoxes) {
      throw new Error('Invalid level format');
    }

    return level as CustomLevel;
  } catch (error) {
    throw new Error('Failed to parse level JSON: ' + (error as Error).message);
  }
}

export function downloadLevel(level: CustomLevel): void {
  const json = exportLevel(level);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${level.name.replace(/\s+/g, '_')}.4dlevel`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function saveToLocalStorage(level: CustomLevel): void {
  try {
    const saved = localStorage.getItem('customLevels');
    const levels = saved ? JSON.parse(saved) : [];
    
    // Update existing or add new
    const index = levels.findIndex((l: CustomLevel) => l.name === level.name);
    if (index >= 0) {
      levels[index] = level;
    } else {
      levels.push(level);
    }
    
    localStorage.setItem('customLevels', JSON.stringify(levels));
  } catch (error) {
    throw new Error('Failed to save to localStorage: ' + (error as Error).message);
  }
}

export function loadFromLocalStorage(): CustomLevel[] {
  try {
    const saved = localStorage.getItem('customLevels');
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
    return [];
  }
}

export function saveDraft(level: CustomLevel): void {
  try {
    localStorage.setItem('editorDraft', JSON.stringify(level));
  } catch (error) {
    console.error('Failed to save draft:', error);
  }
}

export function loadDraft(): CustomLevel | null {
  try {
    const draft = localStorage.getItem('editorDraft');
    return draft ? JSON.parse(draft) : null;
  } catch (error) {
    console.error('Failed to load draft:', error);
    return null;
  }
}
